// Language translations

export const translations = {
  en: {
    // Navigation
    home: 'Home',
    properties: 'Properties',
    architecture: 'Architecture',
    services: 'Services',
    about: 'About',
    contact: 'Contact',
    clientPortal: 'Client Portal',
    adminPortal: 'Admin Portal',
    branches: 'Our Branches',
    
    // Common
    welcome: 'Welcome',
    welcomeBack: 'Welcome back',
    getStarted: 'Get Started',
    learnMore: 'Learn More',
    viewAll: 'View All',
    viewDetails: 'View Details',
    submit: 'Submit',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    back: 'Back',
    continue: 'Continue',
    close: 'Close',
    search: 'Search',
    filter: 'Filter',
    login: 'Login',
    logout: 'Logout',
    signUp: 'Sign Up',
    
    // Home Page
    heroTitle: "We're here to help you every step of the way",
    heroSubtitle: 'Results that Move You',
    heroDescription: 'Expert estate agents in Harrow specializing in sales, lettings, and property management',
    getFreeValuation: 'Get Free Valuation',
    browseProperties: 'Browse Properties',
    whyWorkWithUs: 'Why Work With Harry and Jacobs?',
    featuredProperties: 'Featured Properties',
    whatClientsSay: 'What Our Clients Say',
    readyToMove: 'Ready to Make Your Move?',
    contactToday: 'Contact Us Today',
    comprehensiveServices: 'Comprehensive estate agency services tailored to your needs',
    
    // Properties
    forSale: 'For Sale',
    toRent: 'To Rent',
    bedrooms: 'Bedrooms',
    bathrooms: 'Bathrooms',
    sqft: 'sq ft',
    pcm: 'pcm',
    propertyType: 'Property Type',
    allTypes: 'All Types',
    anyBedrooms: 'Any Bedrooms',
    resetFilters: 'Reset Filters',
    showingProperties: 'Showing properties',
    findPerfectProperty: 'Find Your Perfect Property',
    
    // Architecture
    architecturalServices: 'Architectural Services in London',
    getInstantQuote: 'Get Instant Quote',
    ourServices: 'Our Services',
    designProcess: 'Our Design Process',
    recentProjects: 'Recent Projects',
    getDesignQuote: 'Get Design Quote',
    getBuildCostEstimate: 'Get Build Cost Estimate',
    transformProperty: 'Transform your property with award-winning architectural design',
    
    // Branches
    ourGlobalPresence: 'Our Global Presence',
    servingClients: 'Serving clients across the UK and Middle East',
    uk: 'United Kingdom',
    kuwait: 'Kuwait',
    iraq: 'Iraq',
    saudiArabia: 'Saudi Arabia',
    uae: 'United Arab Emirates',
    london: 'London',
    
    // Client Portal
    myProjects: 'My Projects',
    messages: 'Messages',
    files: 'Files',
    profile: 'Profile',
    newProject: 'New Project',
    createProject: 'Create Project',
    projectName: 'Project Name',
    description: 'Description',
    uploadFiles: 'Upload Files',
    sendMessage: 'Send a message',
    typeMessage: 'Type your message here...',
    
    // Admin Portal
    dashboard: 'Dashboard',
    manageProperties: 'Manage Properties',
    manageProjects: 'Manage Projects',
    manageUsers: 'Manage Users',
    addProperty: 'Add Property',
    addProject: 'Add Project',
    editProperty: 'Edit Property',
    editProject: 'Edit Project',
    
    // Contact
    getInTouch: 'Get In Touch',
    fullName: 'Full Name',
    emailAddress: 'Email Address',
    phoneNumber: 'Phone Number',
    subject: 'Subject',
    message: 'Message',
    sendMessageBtn: 'Send Message',
    
    // Footer
    quickLinks: 'Quick Links',
    contactUs: 'Contact Us',
    openingHours: 'Opening Hours',
    allRightsReserved: 'All rights reserved',
    visitUs: 'Visit Us',
    callUs: 'Call Us',
    emailUs: 'Email Us'
  },
  
  ar: {
    // Navigation
    home: 'الرئيسية',
    properties: 'العقارات',
    architecture: 'الهندسة المعمارية',
    services: 'الخدمات',
    about: 'من نحن',
    contact: 'اتصل بنا',
    clientPortal: 'بوابة العميل',
    adminPortal: 'بوابة الإدارة',
    branches: 'فروعنا',
    
    // Common
    welcome: 'مرحباً',
    welcomeBack: 'مرحباً بعودتك',
    getStarted: 'ابدأ الآن',
    learnMore: 'اعرف المزيد',
    viewAll: 'عرض الكل',
    viewDetails: 'عرض التفاصيل',
    submit: 'إرسال',
    cancel: 'إلغاء',
    save: 'حفظ',
    delete: 'حذف',
    edit: 'تعديل',
    back: 'رجوع',
    continue: 'متابعة',
    close: 'إغلاق',
    search: 'بحث',
    filter: 'تصفية',
    login: 'تسجيل الدخول',
    logout: 'تسجيل الخروج',
    signUp: 'إنشاء حساب',
    
    // Home Page
    heroTitle: 'نحن هنا لمساعدتك في كل خطوة',
    heroSubtitle: 'نتائج تحركك للأمام',
    heroDescription: 'وكلاء عقارات خبراء في هارو متخصصون في المبيعات والتأجير وإدارة العقارات',
    getFreeValuation: 'احصل على تقييم مجاني',
    browseProperties: 'تصفح العقارات',
    whyWorkWithUs: 'لماذا تعمل مع هاري وجاكوبس؟',
    featuredProperties: 'عقارات مميزة',
    whatClientsSay: 'ماذا يقول عملاؤنا',
    readyToMove: 'هل أنت مستعد للانتقال؟',
    contactToday: 'اتصل بنا اليوم',
    comprehensiveServices: 'خدمات عقارية شاملة مصممة خصيصاً لاحتياجاتك',
    
    // Properties
    forSale: 'للبيع',
    toRent: 'للإيجار',
    bedrooms: 'غرف النوم',
    bathrooms: 'الحمامات',
    sqft: 'قدم مربع',
    pcm: 'شهرياً',
    propertyType: 'نوع العقار',
    allTypes: 'جميع الأنواع',
    anyBedrooms: 'أي عدد من الغرف',
    resetFilters: 'إعادة تعيين الفلاتر',
    showingProperties: 'عرض العقارات',
    findPerfectProperty: 'اعثر على العقار المثالي',
    
    // Architecture
    architecturalServices: 'الخدمات المعمارية في لندن',
    getInstantQuote: 'احصل على عرض سعر فوري',
    ourServices: 'خدماتنا',
    designProcess: 'عملية التصميم',
    recentProjects: 'المشاريع الأخيرة',
    getDesignQuote: 'احصل على عرض التصميم',
    getBuildCostEstimate: 'احصل على تقدير تكلفة البناء',
    transformProperty: 'حول عقارك بتصميم معماري حائز على جوائز',
    
    // Branches
    ourGlobalPresence: 'تواجدنا العالمي',
    servingClients: 'نخدم عملائنا في المملكة المتحدة والشرق الأوسط',
    uk: 'المملكة المتحدة',
    kuwait: 'الكويت',
    iraq: 'العراق',
    saudiArabia: 'المملكة العربية السعودية',
    uae: 'الإمارات العربية المتحدة',
    london: 'لندن',
    
    // Client Portal
    myProjects: 'مشاريعي',
    messages: 'الرسائل',
    files: 'الملفات',
    profile: 'الملف الشخصي',
    newProject: 'مشروع جديد',
    createProject: 'إنشاء مشروع',
    projectName: 'اسم المشروع',
    description: 'الوصف',
    uploadFiles: 'تحميل الملفات',
    sendMessage: 'إرسال رسالة',
    typeMessage: 'اكتب رسالتك هنا...',
    
    // Admin Portal
    dashboard: 'لوحة التحكم',
    manageProperties: 'إدارة العقارات',
    manageProjects: 'إدارة المشاريع',
    manageUsers: 'إدارة المستخدمين',
    addProperty: 'إضافة عقار',
    addProject: 'إضافة مشروع',
    editProperty: 'تعديل العقار',
    editProject: 'تعديل المشروع',
    
    // Contact
    getInTouch: 'تواصل معنا',
    fullName: 'الاسم الكامل',
    emailAddress: 'البريد الإلكتروني',
    phoneNumber: 'رقم الهاتف',
    subject: 'الموضوع',
    message: 'الرسالة',
    sendMessageBtn: 'إرسال الرسالة',
    
    // Footer
    quickLinks: 'روابط سريعة',
    contactUs: 'اتصل بنا',
    openingHours: 'ساعات العمل',
    allRightsReserved: 'جميع الحقوق محفوظة',
    visitUs: 'زرنا',
    callUs: 'اتصل بنا',
    emailUs: 'راسلنا'
  }
};
